import { useSelector } from 'react-redux';

export const useAuth = () => {
  const { user, isLoggedIn, isLoading } = useSelector((state) => state.auth);

  return {
    user,
    isLoggedIn,
    isLoading,
    // For backward compatibility with existing code
    getCurrentUser: () => user,
  };
};
